import { LIST_WARNINGS_URL } from "@/constants/Urls";

import axios from "axios";
export default {
  state: {
    list: null,
    isLoadingWarnings: false,
    showWarnings: false,
  },
  actions: {
    getWarnings({state, commit}) {
      state.isLoadingWarnings = true;
      return axios.get(LIST_WARNINGS_URL)
      .then( r => {
        commit("SET_WARNINGS", r.data.data)
        state.showWarnings = true
        return r;
      })
      .finally(() => {
        state.isLoadingWarnings = false;
      })
    },
    markWarningAsRead({state, commit}, warning_id){
      state.isLoadingWarnings = true;
      return axios.post(`/api/v1/warning/${warning_id}`)
      .then( r => {
        commit("SET_WARNINGS", state.list.filter( n => n.id != warning_id ));
        return r;
      })
      .finally(() => {
        state.isLoadingWarnings = false;
      });
    }
  },
  mutations: {
    SET_WARNINGS(state, payload) {
      state.list = payload;
    },
    SHOW_WARNINGS(state, payload = true) {
      state.showWarnings = payload;
    },
  },
  getters:{
    UnreadedWarnings(state){
      return state.list.filter( w => !w.marked_as_readed_at);
    },
    hasNotBlockWarnings(state){
      return state.list.filter( w => w.is_blocking).length === 0;
    },
    hasAnyBlockWarnings(state){
      return state.list.filter( w => w.is_blocking).length > 0;
    }
  }
};
